import React, { useMemo, useContext } from 'react';
import classNames from 'classnames';
import { Panel as BootstrapPanel } from 'react-bootstrap';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  Collapse,
  useCollapseState,
  ValidatedBootstrapPanel,
} from '@bingads-webui-campaign/wizard-jumbo-card';

import { getAdExtensionsSections } from './get-ad-extensions-section';

export const MoreAssetsSection = ({
  otherObjectiveExtensions,
  adExtensionsAssociationsFactory,
  adExtensionsDynamicFeatures,
  onUpdateExtensionsAssociations,
  extensionsAssociations,
  classes,
  campaign,
}) => {
  const i18n = useContext(I18nContext);

  const otherAdExtensionsSections = useMemo(() => getAdExtensionsSections({
    extensionTypes: otherObjectiveExtensions,
    i18n,
    adExtensionsAssociationsFactory,
    adExtensionsDynamicFeatures,
    onUpdateExtensionsAssociations,
    extensionsAssociations,
    campaign,
  }), [adExtensionsAssociationsFactory, adExtensionsDynamicFeatures, campaign, extensionsAssociations, i18n, onUpdateExtensionsAssociations, otherObjectiveExtensions]);

  const [
    allMoreAssetsSections,
    moreAssetsExpandedSections,
    setMoreAssetsExpandedSections,
  ] = useCollapseState(
    otherAdExtensionsSections.sectionsInfo.allSections /* all sections */,
    [] /* initially expanded sections */
  );

  const moreAssetsSection = useMemo(() => (
    <>
      {otherAdExtensionsSections.panels.length > 0 &&
        <ValidatedBootstrapPanel
          defaultExpanded={false}
          className={classNames(classes.collapsiblePanel, 'asset-group-more-assets-panel')}
          render={() => (
            <>
              <BootstrapPanel.Heading>
                <BootstrapPanel.Title toggle>
                  {i18n.getString(_TL_('More assets'))}
                </BootstrapPanel.Title>
              </BootstrapPanel.Heading>
              <BootstrapPanel.Collapse>
                <BootstrapPanel.Body>
                  <div className={classNames('asset-group-more-assets-section')}>
                    <Collapse allPanelItems={allMoreAssetsSections} checkItems skipItemsTypeCheck activeKeys={moreAssetsExpandedSections} setActiveKeys={setMoreAssetsExpandedSections}>
                      {otherAdExtensionsSections.panels}
                    </Collapse>
                  </div>
                </BootstrapPanel.Body>
              </BootstrapPanel.Collapse>
            </>
          )}
        />
      }
    </>
  ), [allMoreAssetsSections, classes.collapsiblePanel, i18n, moreAssetsExpandedSections, otherAdExtensionsSections.panels, setMoreAssetsExpandedSections]);

  return moreAssetsSection;
};
